import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import ApiService from '../ApiService';
import Modal from './Modal';
import '../styles/ItineraryModal.css';
import { trackEvent } from '../analytics';

function ItineraryModal({ isOpen, onClose, user, userLocation, onSelectItinerary }) {
  const { t, i18n } = useTranslation();
  const [itineraries, setItineraries] = useState([]);

  useEffect(() => {
    const fetchSuggestedRoutes = async () => {
      if (isOpen && userLocation) {
        try {
          const itineraries = await ApiService.post('/itinerary/search/', {
            location: {
              latitude: userLocation.lat,
              longitude: userLocation.lng,
            },
            radius: 5000,
            language: i18n.language,
          }, user);

          setItineraries(itineraries);
        } catch (error) {
          console.error('Error fetching suggested routes:', error);
        }
      }
    };

    fetchSuggestedRoutes();
  }, [isOpen, user, userLocation, i18n.language]);

  const itineraryOnClick = (e, itinerary) => {
    e.stopPropagation();
    trackEvent('suggested_itinerary_selected', { itinerary_name: itinerary.name?.text });
    onClose();
    onSelectItinerary(e, itinerary);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="itinerary-content">
        <h2>{t('itinerary_modal.suggested_routes')}</h2>
        <p>{t('itinerary_modal.description')}</p>
        <div className="routes-list">
          {itineraries.map((itinerary, index) => (
            <div key={index} className="route-card">
              <img src="itinerary.png" alt={itinerary.name.text} className="route-map-image" />
              <div className="route-info" onClick={(e) => { itineraryOnClick(e, itinerary) }}>
                <h3>{itinerary.name.text}</h3>
                <p>{`${itinerary.waypoints.length} ${t('itinerary_modal.stops')}`}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Modal>
  )
}

export default ItineraryModal;
